import { useTranslation } from "react-i18next";
import { Alert, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { formatDate } from "@progress/kendo-intl";

function QrScanResult({ result, titleKey = "scan_result" }) {
  const { t } = useTranslation();
  if (!result) return null;

  const used =
    result.qR_OKUTMA_SAYISI ??
    result.qrOkutmaSayisi ??
    null;
  const max =
    result.qR_MAX_OKUTMA ??
    result.qrMaxOkutma ??
    result.toplaM_DAVETLI_SAYISI ??
    null;

  return (
    <Card className="mb-3">
      <CardHeader>
        <CardTitle tag="h5" style={{ marginBottom: 0 }}>
          {t(titleKey)}
        </CardTitle>
      </CardHeader>
      <CardBody>
        <Alert color={result.success ? "success" : "danger"}>
          {t(result.message || "scan_result")}
        </Alert>
        {(result.ad || result.soyaD || result.soyad) && (
          <ul style={{ listStyle: "none", paddingLeft: 0, marginBottom: 0 }}>
            <li>
              <b>{t("name")}:</b> {result.ad} {result.soyad ?? result.soyaD}
            </li>
            {result.etkinliK_ADI || result.etkinlikAdi ? (
              <li>
                <b>{t("event_name")}:</b>{" "}
                {result.etkinliK_ADI || result.etkinlikAdi}
              </li>
            ) : null}
            {used != null && max != null ? (
              <li>
                <b>{t("qr_scan_usage")}:</b> {used}/{max}
              </li>
            ) : null}
            {result.qR_OKUTMA_TARIHI || result.qrOkutmaTarihi ? (
              <li>
                <b>{t("qr_scan_date")}:</b>{" "}
                {formatDate(
                  new Date(result.qR_OKUTMA_TARIHI || result.qrOkutmaTarihi),
                  t("date_formats.shortDateTime"),
                )}
              </li>
            ) : null}
          </ul>
        )}
      </CardBody>
    </Card>
  );
}

export { QrScanResult };
